import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'titleCased'
})
export class TitleCasePipe implements PipeTransform {

  transform(value: string, camelCase: boolean = true): string {
    return value.replace(/([A-Z])/g, (match) => ` ${match}`)
      .replace(/^./, (match) => match.toUpperCase());
  }

}
